<template>
  <div class="hello page-import">
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>客户</el-breadcrumb-item>
          <el-breadcrumb-item>项目</el-breadcrumb-item>
          <el-breadcrumb-item>存档花名册</el-breadcrumb-item>
          <el-breadcrumb-item>导入记录</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-tabs
        v-model="activeName"
        type="card"
        @tab-click="handleClick"
        class="p_roster_table"
      >
        <!-- 招聘角色不能看雇员花名册 -->
        <el-tab-pane
          label="项目列表"
          name="项目列表"
          v-if="checkPermission(['customerList_tab_list'], permissionLists)"
        ></el-tab-pane>
        <el-tab-pane
          label="在职"
          name="在职"
          v-if="checkPermission(['customerList_tab_onjob'], permissionLists)"
        ></el-tab-pane>
        <el-tab-pane
          label="离职"
          name="离职"
          v-if="checkPermission(['customerList_tab_depart'], permissionLists)"
        ></el-tab-pane>
        <el-tab-pane
          label="离职转正"
          name="离职转正"
          v-if="
            checkPermission(['customerList_tab_transform'], permissionLists)
          "
        ></el-tab-pane>
        <el-tab-pane
          label="自离"
          name="自离"
          v-if="
            checkPermission(['customerList_tab_selfdepart'], permissionLists)
          "
        ></el-tab-pane>
        <el-tab-pane
          label="黑名单雇员"
          name="黑名单雇员"
          v-if="
            checkPermission(['customerList_tab_blacklist'], permissionLists)
          "
        ></el-tab-pane>
        <el-tab-pane
          label="导入导出记录"
          name="导入导出记录"
          v-if="
            checkPermission(['customerList_import'], permissionLists) ||
            checkPermission(['customerList_export'], permissionLists)
          "
        ></el-tab-pane>
      </el-tabs>
      <div class="importRecordTable">
        <el-table
          :data="tableData"
          :max-height="tableHeight - 180"
          v-loading="listLoading"
        >
          <!-- <el-table-column align="center" type="selection" width="50"></el-table-column> -->
          <el-table-column align="center" label="序号" width="50">
            <template slot-scope="{ $index }">
              <span>{{
                (Number(infoQuery.currpage) - 1) * Number(infoQuery.pagecount) +
                Number($index) +
                1
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="服务中心"
            prop="StrServCentName"
            min-width="120px"
            fit
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            align="center"
            label="项目名称"
            prop="StrCustName"
            min-width="150px"
            fit
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            align="center"
            label="负责客服"
            prop="StrServUsrName"
            fit
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            align="center"
            label="操作时间"
            prop="opTime"
            min-width="130px"
          ></el-table-column>
          <el-table-column align="center" label="导入进度" width="250px">
            <template slot-scope="scope">
              <div>
                <el-steps
                  :active="scope.row.StrImpEdateStr * 0.05"
                  :process-status="
                    scope.row.StrImpEdateStr == '100' ? 'success' : 'error'
                  "
                  align-center
                  :space="50"
                >
                  <el-step
                    title="解析"
                    :status="
                      scope.row.StrImpEdateStr == '20' ||
                      scope.row.StrImpEdateStr == '40' ||
                      scope.row.StrImpEdateStr == '60' ||
                      scope.row.StrImpEdateStr == '80' ||
                      scope.row.StrImpEdateStr == '100'
                        ? 'success'
                        : new Date().getTime() >
                            new Date(
                              new Date(scope.row.opTime).valueOf() + 360000
                            ).getTime() ||
                          (scope.row.StrImpEdateStr != '0' &&
                            scope.row.StrImpEdateStr != '20' &&
                            scope.row.StrImpEdateStr != '40' &&
                            scope.row.StrImpEdateStr != '60' &&
                            scope.row.StrImpEdateStr != '80' &&
                            scope.row.StrImpEdateStr != '100' &&
                            scope.row.StrImpEdateStr != null)
                        ? 'error'
                        : 'wait'
                    "
                  >
                  </el-step>
                  <el-step
                    title="导入"
                    :status="
                      scope.row.StrImpEdateStr == '40' ||
                      scope.row.StrImpEdateStr == '60' ||
                      scope.row.StrImpEdateStr == '80' ||
                      scope.row.StrImpEdateStr == '100'
                        ? 'success'
                        : new Date().getTime() >
                            new Date(
                              new Date(scope.row.opTime).valueOf() + 360000
                            ).getTime() ||
                          (scope.row.StrImpEdateStr != '0' &&
                            scope.row.StrImpEdateStr != '20' &&
                            scope.row.StrImpEdateStr != '40' &&
                            scope.row.StrImpEdateStr != '60' &&
                            scope.row.StrImpEdateStr != '80' &&
                            scope.row.StrImpEdateStr != '100' &&
                            scope.row.StrImpEdateStr != null)
                        ? 'error'
                        : 'wait'
                    "
                  >
                  </el-step>
                  <el-step
                    title="勘误"
                    :status="
                      scope.row.StrImpEdateStr == '60' ||
                      scope.row.StrImpEdateStr == '80' ||
                      scope.row.StrImpEdateStr == '100'
                        ? 'success'
                        : new Date().getTime() >
                            new Date(
                              new Date(scope.row.opTime).valueOf() + 360000
                            ).getTime() ||
                          (scope.row.StrImpEdateStr != '0' &&
                            scope.row.StrImpEdateStr != '20' &&
                            scope.row.StrImpEdateStr != '40' &&
                            scope.row.StrImpEdateStr != '60' &&
                            scope.row.StrImpEdateStr != '80' &&
                            scope.row.StrImpEdateStr != '100' &&
                            scope.row.StrImpEdateStr != null)
                        ? 'error'
                        : 'wait'
                    "
                  >
                  </el-step>
                  <el-step
                    title="入库"
                    :status="
                      scope.row.StrImpEdateStr == '80' ||
                      scope.row.StrImpEdateStr == '100'
                        ? 'success'
                        : new Date().getTime() >
                            new Date(
                              new Date(scope.row.opTime).valueOf() + 360000
                            ).getTime() ||
                          (scope.row.StrImpEdateStr != '0' &&
                            scope.row.StrImpEdateStr != '20' &&
                            scope.row.StrImpEdateStr != '40' &&
                            scope.row.StrImpEdateStr != '60' &&
                            scope.row.StrImpEdateStr != '80' &&
                            scope.row.StrImpEdateStr != '100' &&
                            scope.row.StrImpEdateStr != null)
                        ? 'error'
                        : 'wait'
                    "
                  >
                  </el-step>
                  <el-step
                    title="完成"
                    :status="
                      scope.row.StrImpEdateStr == '100'
                        ? 'success'
                        : new Date().getTime() >
                            new Date(
                              new Date(scope.row.opTime).valueOf() + 360000
                            ).getTime() ||
                          (scope.row.StrImpEdateStr != '0' &&
                            scope.row.StrImpEdateStr != '20' &&
                            scope.row.StrImpEdateStr != '40' &&
                            scope.row.StrImpEdateStr != '60' &&
                            scope.row.StrImpEdateStr != '80' &&
                            scope.row.StrImpEdateStr != '100' &&
                            scope.row.StrImpEdateStr != null)
                        ? 'error'
                        : 'wait'
                    "
                  >
                  </el-step>
                </el-steps>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="导入结果" min-width="140px">
            <template slot-scope="scope">
              <span
                v-show="
                  scope.row.StrImpEdateStr == '100' &&
                  Number(scope.row.StrErrorLine) > 0
                "
                >导入成功 (有{{
                  scope.row.StrErrorLine
                }}个错误数据,可点击感叹号图片查看原因)</span
              >
              <span
                v-show="
                  scope.row.StrImpEdateStr == '100' &&
                  isNull(scope.row.StrErrorLine)
                "
                >导入成功</span
              >
              <span
                v-show="
                  (scope.row.StrImpEdateStr != '100' &&
                    new Date().getTime() >
                      new Date(
                        new Date(scope.row.opTime).valueOf() + 360000
                      ).getTime()) ||
                  (scope.row.StrImpEdateStr != '0' &&
                    scope.row.StrImpEdateStr != null &&
                    scope.row.StrImpEdateStr != '20' &&
                    scope.row.StrImpEdateStr != '40' &&
                    scope.row.StrImpEdateStr != '60' &&
                    scope.row.StrImpEdateStr != '80' &&
                    scope.row.StrImpEdateStr != '100')
                "
              >
                <span style="color: #ff0000">{{
                  scope.row.StrImpEdateStr == "0" ||
                  scope.row.StrImpEdateStr == "20" ||
                  scope.row.StrImpEdateStr == "40" ||
                  scope.row.StrImpEdateStr == "60" ||
                  scope.row.StrImpEdateStr == "80" ||
                  scope.row.StrImpEdateStr == "100" ||
                  scope.row.StrImpEdateStr == null
                    ? scope.row.StrImpEdateStr == "20"
                      ? "导入失败,请稍后再导入"
                      : "导入失败,请核对花名册数据是否正确"
                    : "导入失败 (" + scope.row.StrImpEdateStr + ")"
                }}</span>
                <!-- <span>{{scope.row.StrImpEdateStr=='20'? '导入失败，请核对花名册数据是否正确后再导入' : '导入失败,'+scope.row.StrImpEdateStr}}</span> -->
              </span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="格式错误数量"
            prop="errorlength"
            min-width="100px"
          >
            <template slot-scope="scope">
              <div
                v-show="
                  scope.row.StrImpEdateStr == '100' &&
                  Number(scope.row.StrErrorLine) > 0
                "
                @click="showErrorDetails(scope.row)"
                class="errorLi"
              >
                <img
                  src="../../assets/employee/images/warning.png"
                  alt=""
                  style="width: 24px"
                />
                <span style="margin-left: 10px">{{
                  scope.row.StrErrorLine
                }}</span>
              </div>
              <div
                v-show="
                  scope.row.StrImpEdateStr == '100' &&
                  isNull(scope.row.StrErrorLine)
                "
              >
                <img
                  src="../../assets/employee/images/success.png"
                  style="width: 24px"
                />
              </div>
              <el-tooltip
                effect="dark"
                :content="
                  scope.row.StrImpEdateStr == '0' ||
                  scope.row.StrImpEdateStr == '20' ||
                  scope.row.StrImpEdateStr == '40' ||
                  scope.row.StrImpEdateStr == '60' ||
                  scope.row.StrImpEdateStr == '80' ||
                  scope.row.StrImpEdateStr == '100' ||
                  scope.row.StrImpEdateStr == null
                    ? scope.row.StrImpEdateStr == '20'
                      ? '导入失败，请稍后再导入'
                      : '导入失败，请核对花名册数据是否正确'
                    : scope.row.StrImpEdateStr
                "
                placement="top"
              >
                <div
                  v-show="
                    (scope.row.StrImpEdateStr != '100' &&
                      new Date().getTime() >
                        new Date(
                          new Date(scope.row.opTime).valueOf() + 360000
                        ).getTime()) ||
                    (scope.row.StrImpEdateStr != '0' &&
                      scope.row.StrImpEdateStr != null &&
                      scope.row.StrImpEdateStr != '20' &&
                      scope.row.StrImpEdateStr != '40' &&
                      scope.row.StrImpEdateStr != '60' &&
                      scope.row.StrImpEdateStr != '80' &&
                      scope.row.StrImpEdateStr != '100')
                  "
                >
                  <img
                    src="../../assets/employee/images/error.png"
                    style="width: 24px"
                  />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="导入数据"
            fixed="right"
            width="200px"
          >
            <template slot-scope="scope">
              <button
                style="margin-left: 9px"
                class="changeServe"
                @click="showDetails(scope.row)"
                v-if="
                  scope.row.StrImpEdateStr == '100' &&
                  isNull(scope.row.StrErrorLine)
                "
              >
                <span>查看详情</span>
              </button>
              <button
                class="changeServe"
                @click="download(scope.row)"
                v-if="userid == '04F97C95-DF0F-4E4F-90DB-234E969EB323'"
              >
                下载
              </button>
              <button
                class="changeError"
                @click="showErrorDetails(scope.row)"
                v-if="
                  Number(scope.row.StrErrorLine) > 0 &&
                  scope.row.StrImpEdateStr == '100'
                "
              >
                修改错误
              </button>
              <button
                class="changeState"
                style="margin-left: 10px"
                v-if="
                  ((new Date().getTime() >
                    new Date(
                      new Date(scope.row.opTime).valueOf() + 360000
                    ).getTime() &&
                    scope.row.StrImpEdateStr != '100') ||
                  (scope.row.StrImpEdateStr != '0' &&
                    scope.row.StrImpEdateStr != null &&
                    scope.row.StrImpEdateStr != '20' &&
                    scope.row.StrImpEdateStr != '40' &&
                    scope.row.StrImpEdateStr != '60' &&
                    scope.row.StrImpEdateStr != '80' &&
                    scope.row.StrImpEdateStr != '100')) && (isBtnHandle == '1')
                "
                @click="queryImportState(scope.row)"
              >
                重新导入
              </button>
              <button
                class="changeState"
                style="margin-left: 10px"
                v-if="
                  (Number(scope.row.StrErrorLine) > 0 &&
                  !isNull(scope.row.StrImpEdateStr)) && (isBtnHandle == '1')
                "
                @click="queryImportState(scope.row)"
              >
                勘误后导入
              </button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-show="totalnum > 0">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="infoQuery.currpage"
            @size-change="handleSizeChange"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total,sizes,prev,pager, next, jumper"
            :total="this.totalnum"
          ></el-pagination>
        </div>
      </div>
    </div>

    <!-- 勘误后导入 -->
    <el-dialog :visible.sync="dialogVisible5" width="700px">
      <div class="diaTitle">导入数据 至 {{ exportName }}</div>
      <el-steps :active="active" finish-status="success" class="steps-box">
        <el-step title="基础信息"></el-step>
        <el-step title="上传导入文件"></el-step>
        <el-step title="导入处理"></el-step>
      </el-steps>
      <div v-if="active == 0" style="margin-top: 15px; padding-bottom: 15px">
        <div>导入模板:</div>
        <div class="storageArea">
          <div class="storageInput" style="margin: 0 20px 0 0">
            <el-select
              v-model="tabName"
              slot="prepend"
              placeholder="请选择"
              filterable
              @change="selectTab"
              disabled
            >
              <el-option
                v-for="(item, index) in this.tableList"
                :key="index"
                :label="item.StrTableName"
                :value="{ value: item.StrTableId, label: item.StrTableName }"
              ></el-option>
            </el-select>
          </div>
        </div>
        <!-- <p>导入至：<span style="margin-left:10px;">{{exportName}}</span></p> -->
      </div>
      <div v-if="active == 1" style="margin-top: 15px; padding-bottom: 15px">
        <div class="note-txt">
          <p style="font-weight: bold">上传文件说明：</p>
          <p>1. 支持文件后缀 xls、xlsx文件。</p>
          <p>2. 请将要上传的内容放在第一个sheet中。</p>
          <p>3. 请不要加密模板文件，将导致错误。</p>
          <p>4. 请不要上传带宏的文件，将导致错误。</p>
          <p>5. 请不要过多的使用格式，如背景色和边框，将可能导致超时。</p>
          <p>
            6.
            导入后只会保留Excel中的数据及通过公式计算后的值，设置的文字颜色等样式、合并的单元格、以及计算公式本身都不会被保留。
          </p>
        </div>
        <div style="margin-top: 10px">请选择导入文件（xls/xlsx格式）:</div>
        <div class="form-item" style="justify-content: space-between">
          <div class="file-box">
            <input
              readonly
              style="width: 368px; height: 32px"
              id="applyLicense"
              type="text"
              v-model="ExcelSrc.fileName"
              autocomplete="off"
            />
            <input
              id="fileInput"
              type="file"
              name="file"
              accept=".xlsx,.xls"
              @change="importf(this)"
              ref="upload"
            />
            <label for="fileInput" class="file-btn">上传</label>
          </div>
          <el-button
            type="text"
            @click="downLoadHandle"
            style="margin-left: 15px; height: 30px"
            >下载模板</el-button
          >
        </div>
        <!-- 提示 -->
        <p style="color: red" v-if="isError">{{ errorTxt }}</p>
        <div class="reimpArea">
          <div style="margin-top: 10px">
            <!-- <el-checkbox v-model="isReset" @change="selectReimp">是否覆盖导入</el-checkbox> -->
          </div>
        </div>
      </div>
      <div v-if="active == 2" style="margin-top: 15px; padding-bottom: 15px">
        <div class="result-box">
          <p>
            <i
              class="el-icon-success"
              style="color: #409eff; margin-right: 5px"
            ></i
            >导入数据正在处理中，导入结果请在’导入记录‘中查看。
          </p>
        </div>
      </div>
      <div
        style="
          display: flex;
          justify-content: flex-end;
          -webkit-justify-content: flex-end;
          padding-bottom: 30px;
        "
      >
        <el-button
          size="small"
          @click="dialogVisible5 = false"
          v-if="active == 0"
          >取消</el-button
        >
        <el-button
          size="small"
          @click="prevSteps"
          v-if="active > 0 && active <= 1"
          >上一步</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="nextSteps"
          v-if="active < 1"
          >下一步</el-button
        >
        <el-tooltip
          effect="dark"
          content="未上传文件不能提交"
          :disabled="!isUploadSuccess"
          placement="top"
        >
          <div style="display: inline-block; margin-left: 10px">
            <el-button
              type="success"
              size="small"
              @click="lastSteps"
              element-loading-text="此操作可能耗费较长时间，请等待..."
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.8)"
              v-loading.fullscreen.lock="fullscreenLoading"
              :disabled="isUploadSuccess"
              v-if="active == 1"
              >提交</el-button
            >
          </div>
        </el-tooltip>
        <el-button
          type="primary"
          size="small"
          @click="backHandle"
          v-if="active == 2"
          >确认并返回</el-button
        >
        <!-- <el-button size="small" @click="resultHandle" v-if="active==2">查看导入结果</el-button> -->
      </div>
      <!-- <input type="file" @change="importf(this)" ref="upload" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"> -->
    </el-dialog>
  </div>
</template>

<script>
import xz from "@/common";
import FUN from "@/fun";
import checkPermission from "@/utils/permission"; // 权限判断函数
export default {
  name: "HelloWorld",
  props: {
    toPermissionLists: {
      type: Array,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      tablePath: this.$store.state.EMP.tablePath,
      tableHeight: 0,
      //表头错误提示
      isError: false,
      errorTxt: "",
      min: 1,
      rowinfo: "",
      listLoading: false,
      dialogVisible2: false,
      dialogVisible: false,
      dialogVisible5: false,
      errorColumn: [],
      totalnum: null,
      //勘误后导入
      ExcelSrc: {
        value: "",
        check: false,
        fileName: "",
        oldexcelpath: "",
      },
      //导入到的项目名称
      exportName: "",
      //导入步骤
      active: 0,
      //是否覆盖
      isReset: false,
      //文件是否已上传
      isFileSuccess: false,
      //导入成功
      dialogVisible6: false,
      //导入的条数
      totalmain: "",
      excelpath: "",
      tableList: [],
      reimp: 0,
      reimpLab: "0",
      process: 0,
      infoPath: "",
      entid: "",
      instname: "",
      StrUserName: "",
      StrSrvCent: "",
      StrObjName: "",
      //下拉选择表格
      tabName: "",
      tabId: "",
      fullscreenLoading: false,
      //已选择的下级
      selectedSubordinate: null,
      //下拉筛选
      showDropScreen: -1,
      currentPage3: 1,
      tableData: [],
      pagecount: 10,
      pageSize: 10,
      //数据参数
      infoQuery: {
        pagecount: 10,
        currpage: 1,
        excelname: "",
        tableid: "XZ_emp_UserBase",
        strsrvcent: "",
        instname: "",
        datestart: "",
        dateend: "",
        strobjname: "",
        strobjinstname: "",
        strusername: "",
        impdate: "",
      },
      //上传excel是否成功-判断下一步按钮是否禁用
      isUploadSuccess: true,
      // 定时器
      timer: null,
      //现在时间
      nowDate: "",
      //旧的excel地址
      oldexcelpath: "",
      //是否全都成功导入
      isEverySuccess: [],
      // 导入时对应的StrTableId
      exportTableId: "",
      userid: "",
      //角色类型
      roleType: "",
      activeName: "",
      permissionLists: [],
      // 是否可导入或删除
      isBtnHandle: "0" // 0不可1可
    };
  },
  watch: {
    // tableData() {
    // this.timer()
    // }
  },
  created() {
    this.roleType = localStorage.loginRoletype;
    this.calHeight();
    this.nowDate = new Date();
    this.userid = Cookies.get("userid-b");
    this.$nextTick(() => {
      this.printButton(this.toPermissionLists);
    });
  },
  methods: {
    checkPermission,
    calHeight() {
      this.tableHeight = Number(document.body.clientHeight);
      console.log("height", this.tableHeight);
    },
    // 判断是否可导入或删除
    isHandleList() {
      xz.getSystemConfig().then((res) => {
        // console.log('kk',res)
        if (res.status == "ok") {
          this.isBtnHandle = res.msg;
        }
      });
    },
    // 父组件传值按钮权限给子组件的值
    printButton(val) {
      // console.log('printButton', val)
      let that = this;
      this.permissionLists = val;
      if (!that.isNull(that.permissionLists)) {
        if (
          that.checkPermission(["customerList_import"], that.permissionLists) ||
          that.checkPermission(["customerList_export"], that.permissionLists)
        ) {
          this.isHandleList();
          that.activeName = "导入导出记录";
          that.getOpeRecord(that.infoQuery);
          that.dataRefreh();
        } else {
          that.activeName = "";
        }
      } else {
        that.activeName = "";
      }
    },
    //切换tab
    async handleClick(tab, event) {
      // console.log('tab',tab, event);
      if (tab.name == "项目列表") {
        this.$router.push({
          path: "/customerList",
          query: {
            currname: "项目列表",
          },
        });
      } else if (
        tab.name == "在职" ||
        tab.name == "离职" ||
        tab.name == "离职转正" ||
        tab.name == "自离"
      ) {
        this.$router.push({
          path: "/customerList",
          query: {
            currname: tab.name,
          },
        });
      } else if (tab.name == "黑名单雇员") {
        this.$router.push({
          path: "/blacklist",
          query: {
            currname: "黑名单雇员",
          },
        });
      } else if (tab.name == "导入导出记录") {
        this.$router.push({
          path: "/operationRecord",
          query: {
            currname: "导入导出记录",
          },
        });
      }
    },
    //判断是否为空(包含0)
    isNull(o) {
      return (
        o == undefined ||
        o == "undefined" ||
        (o + "").indexOf("undefined") > -1 ||
        o == null ||
        o == "" ||
        o == "null" ||
        o == [] ||
        o == 0 ||
        o == "NaN"
      );
    },
    // 清除定时器的代码
    clear() {
      clearInterval(this.timer);
      this.timer = null;
    },
    download(row) {
      // let url = 'http://emp.jobkeji.cn/cloudexcel/' + row.StrExcelPath;
      let url = location.origin + "/cloudexcel/" + row.StrExcelPath;
      const link = document.createElement("a");
      link.download = row.StrCustName;
      link.href = url;
      link.click();
    },
    // 定时刷新数据函数
    async dataRefreh() {
      const thats = this;
      let everyItem;
      // 计时器正在进行中，退出函数
      if (this.timer != null) {
        return;
      }
      // //如果返回的数据有一个不成功就刷新 反之清除定时器
      // 计时器为空，操作
      this.timer = setInterval(() => {
        console.log("刷新" + new Date());
        this.min++;
        let errcount = 0;
        for (let index = 0; index < this.tableData.length; index++) {
          const elementData = this.tableData[index];
          let itemDate =
            elementData.StrImpBdateStr.substring(0, 4) +
            "-" +
            elementData.StrImpBdateStr.substring(4, 6) +
            "-" +
            elementData.StrImpBdateStr.substring(6, 8) +
            " " +
            elementData.StrImpBdateStr.substring(8, 10) +
            ":" +
            elementData.StrImpBdateStr.substring(10, 12) +
            ":" +
            elementData.StrImpBdateStr.substring(12, 14);
          // console.log('1111',new Date().getTime() < new Date((new Date(itemDate)).valueOf() + 360000))
          if (
            new Date().getTime() <
            new Date(new Date(itemDate).valueOf() + 360000)
          ) {
            if (elementData.StrImpEdateStr == null) {
              errcount = errcount + 1;
            } else if (
              elementData.StrImpEdateStr != "100" &&
              elementData.StrImpEdateStr.length < 5
            ) {
              errcount = errcount + 1;
            }
          }
        }
        // console.log('errcount',errcount)
        if (errcount <= 0) {
          clearInterval(this.timer);
        } else {
          thats.getOpeRecord(thats.infoQuery);
        }
      }, 20000);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currpage = `${val}`;
      this.infoQuery.currpage = Number(val);
      this.getOpeRecord(this.infoQuery);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.infoQuery.pagecount = Number(val);
      this.pageSize = parseInt(val);
      this.getOpeRecord(this.infoQuery);
    },
    //筛选下拉
    dropDownScreen() {
      if (this.showDropScreen == -1) {
        this.showDropScreen = 1;
      } else if (this.showDropScreen == 1) {
        this.showDropScreen = -1;
      }
    },
    getTabInfo() {
      const gdata = {
        pagecount: 10,
        currpage: 1,
        tablename: "",
        ctluserid: "",
      };
      xz.getTableData(gdata, Cookies.get("userid-b")).then((res) => {
        // console.log("tab", res);
        this.tableList = res.data;
        for (let i = 0; i < res.data.length; i++) {
          const elementid = res.data[i];
          if (elementid.StrTableId == this.exportTableId) {
            this.tabName = elementid.StrTableName;
          }
        }
      });
    },
    getOpeRecord(data) {
      this.infoQuery = data;
      // this.$store.commit("getLeftNum");
      this.listLoading = true;
      xz.getPathInfo(data).then((res) => {
        // console.log('ss', res)
        this.totalnum = parseInt(res.totalnum);
        if (res.data && res.data.length > 0) {
          res.data.forEach((l) => {
            var opTime =
              l.StrImpBdateStr.substring(0, 4) +
              "/" +
              l.StrImpBdateStr.substring(4, 6) +
              "/" +
              l.StrImpBdateStr.substring(6, 8) +
              " " +
              l.StrImpBdateStr.substring(8, 10) +
              ":" +
              l.StrImpBdateStr.substring(10, 12);
            l["opTime"] = opTime;
          });
          this.tableData = res.data;
        } else {
          this.totalnum = 0;
          this.tableData = [];
        }
        this.listLoading = false;
      });
    },
    //下一步导入
    nextSteps() {
      if (this.active == 0) {
        if (this.tabName == "") {
          this.$message({
            message: "请选择导入模板",
            type: "warning",
          });
          this.active = 0;
          return false;
        }
      }
      this.active += 1;
    },
    //上一步导入
    prevSteps() {
      this.active -= 1;
    },
    //提交导入
    lastSteps() {
      if (this.ExcelSrc.value == "") {
        this.isUploadSuccess = true;
        this.$message({
          message: "请选择文件上传",
          type: "warning",
        });
        this.active = 1;
        return false;
      } else {
        //检查表头是否正确
        let checkData = {
          excelpath: this.excelpath,
          tableid: "XZ_emp_UserBase",
        };
        this.fullscreenLoading = true;
        xz.chkimpdatatbtype(checkData).then((res) => {
          // console.log('checkData',res)
          let resultTxt = res;
          if (this.isNull(res)) {
            this.isError = false;
            this.isUploadSuccess = false;
            const Edata = {
              instname: this.instname,
              tableid: "XZ_emp_UserBase",
              // impexcel:"雇员信息表",
              reimp: this.reimp,
              excelpath: this.excelpath,
              impexcel: this.ExcelSrc.fileName,
              servusrname: this.StrUserName,
              servcentname: this.StrSrvCent,
              custname: this.StrObjName,
              oldexcelpath: this.oldexcelpath,
            };
            // console.log('edata', Edata)
            xz.returnExcelSrc(Edata).then((res) => {
              console.log("res", res);
              if (res) {
                this.active = 2;
              } else {
                this.$message("导入错误");
              }
              this.fullscreenLoading = false;
            });
          } else {
            this.isError = true;
            this.active = 1;
            this.isUploadSuccess = true;
            this.errorTxt = resultTxt;
            //导入操作，如果第一次导入某个文件会触发导入操作，但是第二次导入重复该文件，不会触发操作
            //清空input file值
            var file = document.getElementById("fileInput");
            file.value = "";
            this.fullscreenLoading = false;
          }
        });
      }
    },
    //导入-确认返回
    backHandle() {
      this.dialogVisible5 = false;
      this.infoQuery.currpage = 1;
      this.getOpeRecord(this.infoQuery);
    },
    //修改错误
    showErrorDetails(row) {
      // console.log('修改错误', row)
      let strexcelpath = row.StrExcelPath;
      if (Number(row.StrErrorLine) >= 0) {
        this.$router.push({
          path: "/employee-rosterErroe",
          query: {
            strexcelpath,
            custname: row.StrCustName,
          },
        });
      } else {
        this.$message({
          message: "数据未导入",
          type: "error",
        });
        return;
      }
    },
    //下载模板
    downLoadHandle() {
      xz.getImportMode().then((res) => {
        // console.log('下载模板', res)
        if (res) {
          var d = res.msg.data.StrOutPath;
          d = d.replace('"', "").replace('"', "");
          var path = this.tablePath + d;
          const aTag = document.createElement("a");
          aTag.href = path;
          aTag.click();
        }
      });
    },
    //文件读取
    importf() {
      const fileInput = this.$refs.upload;
      this.excelpath = "";
      //上传前先删除旧的
      xz.delempuserimport({ strObjName: this.infoQuery.strobjname }).then(
        (res) => {
          if (res) {
            FUN.returnExcelSrc(fileInput).then((src) => {
              if (src) {
                // console.log('src0o0', src)
                this.$set(this.ExcelSrc, "value", src.src);
                this.$set(this.ExcelSrc, "check", false);
                this.$set(this.ExcelSrc, "fileName", fileInput.files[0].name);
                // console.log('srccc', this.ExcelSrc)
                //上传excel
                const excelFile = FUN.base64ToFile(
                  this.ExcelSrc.value,
                  this.ExcelSrc.fileName
                );
                const formData = new FormData();
                formData.append("pagename", "empexcel");
                formData.append("action", "save");
                formData.append("userid", Cookies.get("userid-b"));
                formData.append("entid", this.entid);
                formData.append("excel", excelFile, this.ExcelSrc.fileName);
                console.log("formData", formData);
                xz.uploadCert(formData).then((res) => {
                  // console.log('res', res)
                  // this.excelpath = res;
                  if (this.isNull(res) || res == false) {
                    this.$message("上传Excel失败!");
                    this.isUploadSuccess = true;
                  } else {
                    this.errorTxt = "";
                    this.excelpath = res;
                    localStorage.setItem("epath", res);
                    this.isUploadSuccess = false;
                    this.$refs['upload'].value = null;
                  }
                });
              } else {
                this.$message("上传Excel失败!");
              }
            });
          } else {
            this.$message.error("操作失败！");
          }
        }
      );
    },
    // 下拉选择人员
    selectSubordinate(d) {
      this.userId = d.value;
      this.username = d.label;
      // console.log("d", d);
      this.selectedSubordinate = d.label;
    },
    // 下拉选择表格
    selectTab(d) {
      this.tabId = d.value;
      this.tabName = d.label;
      // console.log("d", d);
    },
    // 下拉选择是否覆盖
    selectReimp(d) {
      if (d == true) {
        this.reimp = 1;
        this.reimpLab = 1;
      } else {
        this.reimp = 0;
        this.reimpLab = 0;
      }
      // console.log("d", d);
    },
    //查询导入状态
    queryImportState(val) {
      let data = this.infoQuery;
      // console.log('fds', val, data)
      data.strsrvcent = val.StrServCentName;
      data.strobjname = val.StrCustName;
      this.exportTableId = val.StrTableId;
      this.getTabInfo();
      xz.getPathInfo(data).then((res) => {
        if (res) {
          if (res.data.length > 0) {
            let opTime =
              res.data[0].StrImpBdateStr.substring(0, 4) +
              "/" +
              res.data[0].StrImpBdateStr.substring(4, 6) +
              "/" +
              res.data[0].StrImpBdateStr.substring(6, 8) +
              " " +
              res.data[0].StrImpBdateStr.substring(8, 10) +
              ":" +
              res.data[0].StrImpBdateStr.substring(10, 12);
            if (
              new Date().getTime() >
              new Date(new Date(opTime).valueOf() + 360000).getTime()
            ) {
              this.reImportHandle(val);
            } else {
              if (
                res.data[0].StrImpEdateStr != null &&
                res.data[0].StrImpEdateStr != "20" &&
                res.data[0].StrImpEdateStr != "40" &&
                res.data[0].StrImpEdateStr != "60" &&
                res.data[0].StrImpEdateStr != "80"
              ) {
                // console.log('stateSuccess')
                this.reImportHandle(val);
              } else {
                this.$message({
                  message: "您有一条正在导入的记录，请在导入完成后再导入",
                  duration: 5000,
                  type: "warning",
                });
              }
            }
          } else {
            this.reImportHandle(val);
          }
        } else {
          this.$message.error("系统出错，请联系管理员");
        }
      });
    },
    //勘误后导入
    reImportHandle(row) {
      this.active = 0;
      this.ExcelSrc = {
        value: "",
        check: false,
        fileName: "",
      };
      this.errorTxt = "";
      this.dialogVisible5 = true;
      this.exportName = row.StrCustName;
      this.oldexcelpath = row.StrExcelPath;
      console.log("info", row);
      this.infoPath =
        "雇员花名册>" + row.StrServCentName + ">" + row.StrCustName;
      this.entid = row.StrExcelPath.substring(
        row.StrExcelPath.indexOf("/") + 1,
        row.StrExcelPath.lastIndexOf("/")
      );
      console.log("dd", this.entid);
      this.instname = row.StrImpInstName;
      this.StrUserName = row.StrServUsrName;
      this.StrSrvCent = row.StrServCentName;
      this.StrObjName = row.StrCustName;
    },
    //查看详情
    showDetails(val) {
      // console.log('val',val.StrExcelPath)
      let path = val.StrExcelPath;
      let errorLength = val.errorlength;
      this.$router.push({
        path: "/employee-recoedDetails",
        query: {
          path,
          errorLength,
        },
      });
    },
  },
  beforeDestroy() {
    // 在页面销毁后，清除计时器
    this.clear();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.p_roster_table.el-tabs--card {
  width: 100%;
  background-color: #fff;
}
.page-import .el-dialog .el-dialog__header {
  padding: 0;
}
.page-import .el-step__title {
  font-size: 13px;
  line-height: 24px;
}
.page-import .el-step__icon {
  width: 20px;
  height: 20px;
  font-size: 12px;
}
.page-import .dialog .el-dialog__body {
  padding: 20px 20px 0 20px;
}
</style>
<style scoped>
.changeState,
.changeServe,
.changeError {
  line-height: 20px;
}
.result-box {
  padding: 15px 10px;
  border-radius: 5px;
  background-color: rgba(103, 194, 58, 0.1);
}
.file-box {
  position: relative;
}
.top-right {
  display: flex;
  align-items: center;
}
.form-item {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333333;
  margin-bottom: 20px;
}

.form-item label {
  width: 56px;
  text-align: right;
}

.form-item span {
  color: #ff3228;
}

.form-item input {
  width: 400px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #cccccc;
  padding-left: 14px;
  box-sizing: border-box;
  margin-top: 10px;
}

/* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
#fileInput {
  width: 120px;
  margin-left: 8px;
  filter: Alpha(opacity=0);
  -moz-opacity: 0;
  opacity: 0;
  position: absolute;
  right: 37px;
  z-index: 2;
}
/* 这是主要的，文件上传按钮的样式 */
.file-btn {
  display: inline-block;
  width: 54px;
  height: 30px;
  background: #fff;
  border: 1px solid #ccc;
  /* border-radius:2px; */
  text-align: center !important;
  line-height: 32px;
  color: #333333;
  /* position: relative;
    top: 5px;
    left: 0; */
  margin-left: 8px;
}
/* 单行文字截断，展示文件名的input框用的 */
#applyLicense {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rIcon {
  font-size: 18px;
  color: #50d4ab;
}
</style>

<style>
/* .importRecordTable .el-table td {
  padding: 5px 0;
}
.importRecordTable .el-table th {
  padding: 10px 0;
} */
.changeError {
  padding: 5px 10px;
  border: solid 1px red;
  font-size: 12px;
  color: red;
  border-radius: 4px;
  background-color: #fff;
}
.screenInput .el-input {
  width: 70%;
  margin-left: 5px;
}

.formScreenInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-top: 10px;
}
.formScreenInput .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.dialog .el-dialog .el-dialog__header {
  background: #fff;
}
/* .importRecordTable .el-table .cell{
  height: 24px;
  line-height: 24px;
} */
</style>
